
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Cart } from "@/types/Cart";
import {
  CartItem,
  CartItemPaymentTerms,
  CartItemCode,
} from "@/types/cart-item";
import Loader from "@/components/Loader.vue";
import StatusComponent from "@/components/StatusComponent.vue";
import IProduct from "@/models/protocols/IProduct";
import RatesService from "@/services/RatesService";
import IRate from "@/models/protocols/IRate";

const { State } = namespace("Root");

@Component({
  components: {
    Loader,
    StatusComponent,
  },
})
export default class CheckoutCoverage extends Vue {
  @State("cart") cart!: Cart;
  @Prop() item!: CartItem;
  @Prop() wag_cat!: IProduct;
  @Prop() submitted!: boolean;

  loading = false;
  coverage_amounts: number[] = [];
  // This is from Magento Products for Progressive
  deductible_amounts: number[] = [];
  deductible_amounts_object: any[] = [];
  rates: IRate[] = [];
  allowed_payment_terms: any[] = [];
  payment_terms_loaded = false;
  show_deductible_list = true;
  show_payment_terms_list = true;

  /**
   * Gets status component
   */
  status() {
    return this.$refs.status as any;
  }

  @Watch("cart.stateValue")
  watchStateValue(newValue: string) {
    // eslint-disable-next-line no-console
    console.log("watchStateValue", newValue);
    this.stateChanged();
  }

  @Watch("allowed_payment_terms", { immediate: true, deep: true })
  watchAllowedPaymentTerms(newValue: any[]) {
    this.show_payment_terms_list = newValue && newValue.length > 1;
  }

  /**
   * Watch when current rate changes and update the item.
   */
  // @Watch("item", { immediate: true, deep: true })
  onItemChanged(method: string = "") {
    // eslint-disable-next-line no-console
    // console.log("changed ", method);
    this.cart.quoteId = -1;
    this.cart.saved = false;
    this.cart.persist();
  }

  async created() {
    console.log("wag_cat", this.wag_cat);
    console.log("Item", this.item);
    // We have been set previously. Just refetch rates.
    if (this.item.coverage > 0 && this.item.deductible >= 0) {
      if (!this.item.match_with_first) {
        // eslint-disable-next-line no-console
        console.log("created");
        await this.fetchRates();
      }
    } else {
      if (this.indexOfCode > 1) {
        this.item.match_with_first = true;
      }
    }
    if (this.wag_cat.coverage_amounts) {
      this.wag_cat.coverage_amounts.forEach((item) => {
        this.coverage_amounts.push(Number(item.value));
      });
    }
    this.coverage_amounts.sort((a, b) => {
      return a - b;
    });

    if (this.wag_cat.deductibles) {
      this.wag_cat.deductibles.forEach((item) => {
        this.deductible_amounts.push(Number(item.value));
      });
      this.deductible_amounts_object = this.wag_cat.deductibles;
    }
    this.deductible_amounts.sort((a, b) => {
      return a - b;
    });
    if (this.deductible_amounts.length == 1) {
      this.show_deductible_list = false;
      this.item.deductible = this.deductible_amounts[0];
      this.item.deductible_object = this.deductible_amounts_object[0];
    }
    if (this.wag_cat.coverage_types && this.wag_cat.coverage_types.length > 0) {
      this.item.coverage_type = Number(this.wag_cat.coverage_types[0].value);
    }

    // if (this.item.policy_term == 0) {
    //   this.item.policy_term = 1;
    // }

    this.onValidated(this.validated);
  }

  stateChanged() {
    this.item.policy_term = 0;
    this.rates = [];
    this.onItemChanged("stateChanged");
    if (this.cart.stateValue === "") {
      // This is deductible no value. Reset other connected values.
      this.allowed_payment_terms = [];
      this.item.payment_terms = CartItemPaymentTerms.undefiend;
      this.show_payment_terms_list = true;
      this.item.due_today = 0;
      this.updateMatched();
      return;
    }
    if (this.item.coverage > 0 && this.item.deductible > -1) {
      // eslint-disable-next-line no-console
      console.log("stateChanged");
      this.fetchRates();
    }
  }

  /**
   * Fetch the WAG rates from API.
   */
  async fetchRates(): Promise<void> {
    this.loading = true;
    console.log("ITEM", this.item);
    RatesService.get(this.item, this.cart.stateValue, this.wag_cat)
      .then((data) => {
        this.loading = false;
        this.rates = data;
        //this.termChange(null);
      })
      .catch((error) => {
        this.loading = false;
        this.status().error_response(error);
      });
  }

  /**
   * Get the item name, with or without index, of more items of the same type.
   */
  get itemName() {
    if (this.cart.countByCode(this.item.code) == 1 || this.item.model != "") {
      return this.item.name + " " + this.item.model;
    } else {
      return (
        this.item.name +
        " " +
        this.cart.indexOfCode(this.item.code, this.item.id)
      );
    }
  }

  /**
   * Get the index of this item from possible
   * other items of specified type.
   */
  get indexOfCode() {
    return this.cart.indexOfCode(this.item.code, this.item.id);
  }

  /**
   * Deductible has been changed. Fetch rates only if deductible >=0 and coverage > 0.
   */
  async deductibleSelected() {
    this.item.policy_term = 0;
    this.rates = [];
    this.onItemChanged("deductibleSelected");
    if (this.item.deductible < 0) {
      // This is deductible no value. Reset other connected values.
      this.allowed_payment_terms = [];
      this.item.payment_terms = CartItemPaymentTerms.undefiend;
      this.show_payment_terms_list = true;
      this.item.due_today = 0;
      this.updateMatched();
      return;
    }

    if (
      this.item.coverage > 0 &&
      this.item.deductible > -1 &&
      this.cart.stateValue !== ""
    ) {
      // eslint-disable-next-line no-console
      this.item.deductible_object = this.deductible_amounts_object.find(
        (item) => item.value == this.item.deductible
      );
      console.log("deductibleSelected");
      await this.fetchRates();
    }
  }

  /**
   * Selected term has change. Read new parameters from rates.
   */
  termChange(e) {
    // eslint-disable-next-line no-console
    if (e && e.type == "change") {
      this.onItemChanged("termChange");
    }
    if (this.item.coverage == 0) {
      return;
    }
    if (this.item.policy_term == 0) {
      return;
    }
    if (this.item.payment_terms == CartItemPaymentTerms.undefiend) {
      console.log("nulll1");
      this.getAvailablePaymentTerms();
      if (this.allowed_payment_terms.length == 1) {
        this.item.payment_terms = this.allowed_payment_terms[0].value;
      }
      this.calculateDueToday();
      this.updateMatched();

      return;
    }
    this.onCurrentRateChanged();
  }

  /**
   * Get available payment terms, depending on the current rate
   */
  getAvailablePaymentTerms() {
    this.payment_terms_loaded = false;
    this.allowed_payment_terms = [];
    let terms: any[] = [];
    // Always allowed
    if (this.item.policy_term_text !== "1 Year") {
      terms.push({
        value: CartItemPaymentTerms.InFull,
        name: "Paid in Full",
        description: "This policy must be paid in full",
      });
    } else {
      // Monthly
      if (this.allowMonthly) {
        terms.push({
          value: CartItemPaymentTerms.Monthly,
          name: "Monthly Billing",
          description: "",
        });
      }
      // Annual Auto Renew
      // if (this.allowAutoRenew) {
      terms.push({
        value: CartItemPaymentTerms.AnnualAutoRenew,
        name: "Annual Billing",
        description: "",
      });
      // }
    }

    this.allowed_payment_terms.push.apply(this.allowed_payment_terms, terms);
    this.show_payment_terms_list = this.allowed_payment_terms.length > 1;
    this.payment_terms_loaded = true;
  }

  /**
   * Update current item.payment_terms
   */
  calculatePaymentTerms() {
    if (!this.currentRate.term) {
      return;
    }
    this.getAvailablePaymentTerms();
    if (
      this.item.payment_terms == CartItemPaymentTerms.Monthly &&
      !this.allowMonthly
    ) {
      this.item.payment_terms = 0;
    } else if (
      this.item.payment_terms == CartItemPaymentTerms.AnnualAutoRenew &&
      this.item.policy_term_text !== "1 Year"
    ) {
      this.item.payment_terms = 0;
    } else if (
      this.item.payment_terms == CartItemPaymentTerms.InFull &&
      this.item.policy_term_text === "1 Year"
    ) {
      this.item.payment_terms = 0;
    }

    if (this.item.payment_terms == CartItemPaymentTerms.undefiend) {
      console.log("null2");
      if (this.allowed_payment_terms.length > 0) {
        this.item.payment_terms = this.allowed_payment_terms[0].value;
      } else {
        this.item.payment_terms = CartItemPaymentTerms.InFull;
      }
    }
  }

  /**
   * Is monthly payment available?
   */
  get allowMonthly() {
    if (!this.currentRate) {
      return false;
    }

    return (
      this.currentRate.allow_monthly && this.currentRate.installment_total > 5
    );
  }

  /**
   * Is Annual Auto Renew payment available?
   */
  get allowAutoRenew() {
    if (!this.currentRate) {
      return false;
    }

    return (
      this.currentRate.allow_auto_renew &&
      this.currentRate.installment_total > 0
    );
  }

  /**
   * Calculate due_today.
   */
  calculateDueToday() {
    if (this.item.payment_terms == CartItemPaymentTerms.undefiend) {
      console.log("null3");
      this.item.due_today = 0;
    } else if (
      this.item.payment_terms == CartItemPaymentTerms.InFull ||
      this.item.payment_terms == CartItemPaymentTerms.AnnualAutoRenew
    ) {
      this.item.due_today = this.currentRate.full_term_total;
      this.item.processing_fee_sku = this.currentRate.ProcessingFeeSKU;
    } else {
      this.item.due_today = this.currentRate.installment_total;
      this.item.processing_fee_sku =
        this.currentRate.ProcessingFeeSKU_Installment;
    }
  }

  /**
   * Current rate will get updated when we fetch rates.
   */
  get currentRate(): IRate {
    console.log("Current Rate", this.rates);
    let rate = this.rates.find((rate) => {
      this.item.policy_term_text = rate.term;
      return this.item.policy_term == parseInt(rate.term_value);
    });
    if (!rate) {
      rate = {
        full_term_premium: 0,
        discount: 0,
        installment_total: 0,
        installment_premium: 0,
        allow_auto_renew: false,
        allow_monthly: true,
        IsNonRenew: true,
        school_indicator: false,
        full_term_proc_fee: 0,
        installment_proc_fee: 0,
        ProcessingFeeSKU: "",
        ProcessingFeeSKU_Installment: "",
        ProcessingFee_Installment: 0,
        SKU: "",
        term: "",
        full_term_total: 0,
      };
    }
    return rate;
  }

  /**
   * Watch when current rate changes and update the item.
   */
  @Watch("currentRate")
  onCurrentRateChanged() {
    // this.onItemChanged();
    this.item.discount = this.currentRate.discount;
    this.item.sku = this.currentRate.SKU;
    this.item.processing_fee = this.currentRate.full_term_proc_fee;
    if (this.item.payment_terms == CartItemPaymentTerms.Monthly) {
      this.item.processing_fee = this.currentRate.installment_proc_fee;
    }
    this.item.installmentPremium = this.currentRate.installment_premium;
    this.item.is_non_renew = this.currentRate.IsNonRenew;
    this.calculatePaymentTerms();
    this.calculateDueToday();
    this.cart.processing_fee = this.item.processing_fee;
    this.updateMatched();
    this.cart.persist();
    this.onValidated(this.validated);
    if (this.currentRate.term !== "1 Year") {
      this.item.payment_terms = CartItemPaymentTerms.InFull;
    }
  }
  /**
   * Update matched items from the cart, with this one,
   * if this one is the first of its type.
   */
  updateMatched() {
    if (this.cart.getFirstOfType(this.item.code) == this.item) {
      this.cart.updateMatchedItemsCoverage(this.item);
    }
  }

  /**
   * Coverage value has been changed.
   */
  async coverageChanged() {
    this.item.policy_term = 0;
    this.rates = [];
    this.onItemChanged("coverageChanged");
    this.allowed_payment_terms = [];
    this.item.payment_terms = 0;
    this.show_payment_terms_list = true;
    this.item.due_today = 0;
    this.updateMatched();
    if (this.item.coverage == 0) {
      //This is coverage no value. Reset other connected values.
      return;
    }

    // We cannot fetch rate until policy term is selected, too
    if (this.item.policy_term == 0) {
      this.updateMatched();
      // return;
    }
    console.log("coverageChanged", this.item.deductible);
    // If only one deductible value, set it to the item
    if (this.deductible_amounts.length == 1 && this.cart.stateValue !== "") {
      this.item.deductible = this.deductible_amounts[0];
      this.item.deductible_object = this.deductible_amounts_object[0];
      // eslint-disable-next-line no-console
      console.log("coverageChanged1");
      await this.fetchRates();
    } else {
      if (this.item.deductible >= 0 && this.cart.stateValue !== "") {
        // eslint-disable-next-line no-console
        console.log("coverageChanged2");
        await this.fetchRates();
      }
      this.cart.persist();
    }
  }

  /**
   * User selected no, do not match this to the first item of this type.
   */
  async noMatch() {
    if (this.item.coverage > 0) {
      if (this.deductible_amounts.length == 1) {
        this.item.deductible = this.deductible_amounts[0];
        this.item.deductible_object = this.deductible_amounts_object[0];
        // eslint-disable-next-line no-console
        console.log("noMatch1");
        await this.fetchRates();
      } else {
        this.cart.persist();
        // eslint-disable-next-line no-console
        console.log("noMatch2");
        await this.fetchRates();
      }
    }
  }

  /**
   * User selected yes, match this with the first of this item type.
   */
  async yesMatch() {
    // Get the first of this item type, and update it according to it.
    let master = this.cart.getFirstOfType(this.item.code);
    if (master) {
      this.cart.updateMatchedItemsCoverage(master);
      this.cart.persist();
    }
  }

  /**
   * Checks if this form is validated.
   */
  get validated() {
    if (this.item.match_with_first) {
      return true;
    }

    return (
      this.item.coverage > 0 &&
      this.item.deductible >= 0 &&
      this.item.policy_term > 0 &&
      this.item.payment_terms > 0
    );
  }

  get allowPolicyTerm() {
    if (
      this.item.coverage !== 0 &&
      this.cart.stateValue !== "" &&
      this.item.deductible > -1
    )
      return true;
    else return false;
  }

  showValidationError(value: number, isDeductivle = false) {
    if (isDeductivle) {
      return value < 0 && this.submitted;
    } else {
      return value <= 0 && this.submitted;
    }
  }

  /**
   * When validated changes, fire validated event.
   * @param newValue
   */
  @Watch("validated", { deep: true })
  onValidated(newValue: any) {
    this.$emit("validated", this.item.id, newValue);
  }

  /**
   * Show what is covered info modal.
   */
  showWhatsCovered() {
    this.$router.push({
      name: `compare.${this.item.code}`,
      params: { dest: "wizard.one" },
    });
  }
}
